<template>
    <!-- 兑换活动管理-兑换统计组件 -->
    <a-card :title="title" :bordered="bordered">
        <a-row>
            <a-col :span="3">
                <span class="text-color-45">生成数量</span>
                <div class="font-bigger text-color-85">{{dataDetail.generateNum && dataDetail.generateNum.toLocaleString()}}</div>
            </a-col>
            <a-col :span="3">
                <span class="text-color-45">兑换数量</span>
                <div class="font-bigger text-color-85">{{dataDetail.generateCashNum && dataDetail.generateCashNum.toLocaleString()}}</div>
            </a-col>
            <a-col :span="3" style="border-right:1px solid #ddd" class="mr48">
                <span class="text-color-45">使用数量</span>
                <div class="font-bigger text-color-85">{{dataDetail.useNum && dataDetail.useNum.toLocaleString()}}</div>
            </a-col>
            <a-col :span="3">
                <span class="text-color-45">可售数量</span>
                <div class="font-bigger text-color-85">{{dataDetail.putableNum && dataDetail.putableNum.toLocaleString()}}</div>
            </a-col>
            <a-col :span="3">
                <span class="text-color-45">团购订单数</span>
                <div class="font-bigger text-color-85">{{dataDetail.groupOrderNum && dataDetail.groupOrderNum.toLocaleString()}}</div>
            </a-col>
            <a-col :span="3">
                <span class="text-color-45">团购销售数量</span>
                <div class="font-bigger text-color-85">{{dataDetail.groupSellNum && dataDetail.groupSellNum.toLocaleString()}}</div>
            </a-col>
            <a-col :span="3">
                <span class="text-color-45">团购销售金额</span>
                <div class="font-bigger text-color-85">{{dataDetail.groupSellPrice && dataDetail.groupSellPrice.toLocaleString()}}</div>
            </a-col>
        </a-row>
    </a-card>
</template>

<script type="text/javascript">
    export default {
        name: "exchangeAcount",
        components: {},
        props: {
            dataDetail: {
                default: {},
                default: () => {return {}}
            },
            bordered: {
                type: Boolean,
                default: true,
            },
            title: {
                type: String,
                default: "",
            }
        },
        data() {
            return {};
        },
        methods: {},
        beforeCreate() {},
        created() {},
        mounted() {}
    };
</script>
<style lang="scss">
</style>